export class StringUtils {
  static getName(nameType: 'last' | 'first', name: string): string {
    return nameType === 'last'
      ? `${name.replace(name.split(' ')[0], '')}`
      : `${name.split(' ')[0]}`;
  }
}
